import $ from 'jquery';
import React, { PureComponent } from 'react';
import onClickOutside from 'react-onclickoutside';

import { defer } from 'utilities/browser';
import { getCaretCoords } from 'utilities/dom';

import './styles.less';

const DROP_DOWN_Y_OFFSET = 28;

/**
 * Generic drop down menu styled loom style.
 * Props: suggestions, query, onRowSelect
 */

const MentionsDropDown = class extends PureComponent {
  state = {
    query: '',
    visible: false,
    suggestions: [],
    selection: 0,
  };

  render() {
    const { suggestions, visible, selection, query: atQuery } = this.state;
    const { title, showTrigger, trigger } = this.props;
    const query = atQuery && atQuery.slice(this.props.trigger.length);
    const customStyles = {};

    if (!suggestions || suggestions.length === 0 || !visible) {
      return <div />;
    }

    const rowsJSX = suggestions.map((suggestion, ind) => {
      const { name, username, avatar } = suggestion;
      const emphasized = (
        <span className="emphasis">{`${showTrigger ? trigger : ''}${name.slice(
          0,
          query.length
        )}`}</span>
      );

      const rest = name.slice(query.length);

      const rowClass = selection === ind ? ' selected' : '';

      if (name && !username && !avatar) {
        return (
          <div
            className={`name-only${rowClass}`}
            onMouseDown={() => this.handleDropDownSelection()}
            onMouseOver={() => this.setState({ selection: ind })}
            key={ind}
          >
            {emphasized}
            {rest}
          </div>
        );
      }

      return (
        <div
          className={`dm-row${rowClass}`}
          key={ind}
          onMouseDown={() => this.handleDropDownSelection()}
          onMouseOver={() => this.setState({ selection: ind })}
        >
          <img src={avatar} className="photo" />
          <div className="name">
            {emphasized}
            {rest}
          </div>
          <div className="username">{username}</div>
        </div>
      );
    });

    return (
      <div
        className="mentions-drop-down"
        style={customStyles}
        ref={me => (this.menu = me)}
      >
        <div className="title">{title}</div>
        {rowsJSX}
      </div>
    );
  }

  handleDropDownSelection = () => {
    const { suggestions, selection, query } = this.state;
    const { trigger } = this.props;
    const mention = suggestions[selection];

    this.setState({ visible: false, suggestions: [], query: '' });
    this.props.handleSelection({ result: mention, query }, trigger);
  };

  componentDidUpdate(prevProps, prevState) {
    if (this.menu && this.props.selfPositioning) {
      const { x, y } = getCaretCoords(window);

      if (x && y) {
        this.menu.style.left = `${x}px`;
        this.menu.style.top = `${y + DROP_DOWN_Y_OFFSET}px`;
      }
    }

    if (prevState.query === this.state.query) {
      return;
    }

    const { suggestions = [] } = this.props;
    const { query, visible } = this.state;

    const filtered = suggestions.filter(row =>
      row.name.toLowerCase().startsWith(query.slice(1).toLowerCase())
    );

    if (!filtered || filtered.length === 0) {
      this.setState({ visible: false });

      return;
    }

    if (visible) {
      this.setState({ suggestions: filtered });
    }
  }

  componentDidMount() {
    const { editorClass } = this.props;

    const elThis = this;

    defer(() => {
      // we attach listeners to both the sidebar editor and mobile editor
      $(editorClass).each(function() {
        const $editor = this;

        if (!$editor) {
          return;
        }

        $editor.addEventListener('keydown', event => {
          const { suggestions, selection, visible, query } = elThis.state;
          const maxPos = suggestions.length - 1;

          if (!visible) {
            return;
          }

          switch (event.key) {
            case 'ArrowDown':
              if (selection === maxPos) {
                elThis.setState({ selection: 0 });
              } else {
                elThis.setState({ selection: selection + 1 });
              }

              break;
            case 'ArrowUp':
              if (selection === 0) {
                elThis.setState({ selection: maxPos });
              } else {
                elThis.setState({ selection: selection - 1 });
              }

              break;
            case 'Enter':
              if (visible && selection <= maxPos) {
                elThis.handleDropDownSelection();
              } else {
                elThis.setState({ visible: false, query: '' });
              }

              break;
            case 'Backspace':
              // this is once the query is only the trigger, so when the query
              // is equal to the trigger, and we hit backspace, we want the drop
              // down to disappear
              if (visible && query.slice(-1) === elThis.props.trigger) {
                elThis.setState({
                  visible: false,
                  selection: 0,
                  suggestions: [],
                });
              }

              if (query.length === 0) {
                elThis.setState({ visible: false, suggestions: [] });
              } else {
                elThis.setState({ query: query.slice(0, -1) });
              }

              // we return instead of break here because we donot want to prevent
              // the default action of actually clearing the text in the editor
              return;
            case 'Escape':
              elThis.setState({
                visible: false,
                selection: 0,
                suggestions: [],
              });
              break;
            default:
              return;
          }

          event.preventDefault();
        });

        $editor.addEventListener('keypress', event => {
          const { query, visible } = elThis.state;

          if (visible) {
            elThis.setState({ query: `${query}${event.key}` });
          } else {
            if (event.key === elThis.props.trigger) {
              elThis.setState({ visible: true, query: elThis.props.trigger });
            }
          }
        });
      });
    });
  }

  handleClickOutside(e) {
    // we don't want to put out the toggle action in case the clicks are within
    // the drawer/on the bubble as they'll take care of it themselves
    if (
      !this.state.visible ||
      $(e.target).parents('.mentions-drop-down').length
    ) {
      return;
    }

    this.setState({ visible: false });
  }
};

export default onClickOutside(MentionsDropDown);
